export const GanttConfig = {
  LOAD_BEFORE: 3,
  LOAD_AFTER: 7,
  SINGLE_ELEMENT_WIDTH: 176,
  TIME_MAKER_TIMEOUT: 60_000,
  SMALL_NODE_WIDTH: 52,
};
